import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  pageBreakCta: ({ lightVariant }) => ({
    background: lightVariant ? theme.palette.blue.light25 : theme.palette.secondary.main,
    color: lightVariant ? theme.palette.secondary.light : 'white',
    textAlign: 'center',
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(9),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(10),
      paddingBottom: theme.spacing(12),
    },
  }),
  titleContent: {
    paddingBottom: theme.spacing(2),
  },
  subtitle: ({ lightVariant }) => ({
    paddingBottom: theme.spacing(2),
    color: lightVariant && 'black',
  }),
  descriptionContent: ({ lightVariant }) => ({
    margin: 'auto',
    maxWidth: '626px',
    paddingBottom: theme.spacing(5),
    color: lightVariant ? 'black' : 'white',
  }),
  avatar: {
    margin: 'auto',
    width: '110px',
    height: 110,
    marginBottom: theme.spacing(3),
  },
  nameContent: {
    color: 'white',
    marginBottom: theme.spacing(1),
  },
  roleContent: {
    color: 'white',
  },
}))

export default useStyles
